import React, { FC } from 'react';

import { useBreakpoints } from 'hooks/useBreakpoints';
import { SubjectImage, SubjectImageProps } from 'components/SubjectImage/SubjectImage';
import { SubjectLottie, SubjectLottieProps } from 'components/SubjectLottie/SubjectLottie';

export type SubjectMediaProps = SubjectImageProps & SubjectLottieProps;

export const SubjectMedia: FC<SubjectMediaProps> = ({ entry, ...props }) => {
  const { browser } = useBreakpoints();

  if (!entry) return null;

  const { image, tabletImage, mobileImage } = entry;

  const fileDesktop = image?.file;
  const fileMobile = mobileImage?.file;
  const fileTablet = tabletImage?.file;
  const isMobile = browser.is.mobile;
  const isTablet = browser.is.tablet;

  if (!fileDesktop) return null;

  let assetFile = fileDesktop;

  if (isMobile && fileMobile) {
    assetFile = fileMobile;
  } else if (isTablet && fileTablet) {
    assetFile = fileTablet;
  }

  const isLottieSubject = assetFile.contentType === 'application/json';
  if (isLottieSubject) {
    return <SubjectLottie entry={entry} {...props} />;
  }

  const { playWhenInView, ...restProps } = props;
  return <SubjectImage entry={entry} {...restProps} />;
};
